import React, { lazy } from "react";

const LazyUtcMappingRules = lazy(() => import("./UtcMappingRules"));

const UtcMappingRules = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyUtcMappingRules {...props} />;

export default UtcMappingRules;
